function isSaoPauloCity(city) {
  const normalized = (city || '').trim().toLowerCase();
  return normalized === 'são paulo' || normalized === 'sao paulo';
}

class GeoShippingGoal extends HTMLElement {
  connectedCallback() {
    const cachedCity = sessionStorage.getItem('geoShippingGoalCity');
    if (cachedCity !== null) {
      console.log('[geo-shipping-goal] cidade detectada (cache):', cachedCity);
      this.applyCity(cachedCity);
      return;
    }

    this.detectCityByIp();
  }

  async detectCityByIp() {
    try {
      const response = await fetch('https://get.geojs.io/v1/ip/geo.json');
      const data = await response.json();
      const city = data.city || '';
      sessionStorage.setItem('geoShippingGoalCity', city);
      console.log('[geo-shipping-goal] cidade detectada (IP):', city);
      this.applyCity(city);
    } catch (error) {
      console.warn('[geo-shipping-goal] falha ao detectar cidade por IP:', error);
    }
  }

  applyCity(city) {
    this.classList.toggle('hidden', !isSaoPauloCity(city));
  }
}
customElements.define('geo-shipping-goal', GeoShippingGoal);
